module.exports = __webpack_public_path__ + "img/activity_2.82562260.png";